import api from './api';

// 企微群活码服务
const weworkGroupJoinWayService = {
  // 获取群活码列表（分页）
  getGroupJoinWays: async (params = {}) => {
    try {
      console.log('🚀 准备获取群活码列表，参数：', params);
      console.log('📍 请求路径：/wework/group-join-way');
      
      const response = await api.get('/wework/group-join-way', { params });
      console.log('✅ 获取群活码列表成功，数据：', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ 获取群活码列表失败:', {
        错误信息: error.message,
        状态码: error.response?.status,
        响应数据: error.response?.data,
        请求配置: error.config
      });
      throw error;
    }
  },

  // 获取群活码详情
  getGroupJoinWayById: async (id) => {
    try {
      console.log('🚀 准备获取群活码详情，ID：', id);
      const response = await api.get(`/wework/group-join-way/${id}`);
      console.log('✅ 获取群活码详情成功');
      return response.data;
    } catch (error) {
      console.error('❌ 获取群活码详情失败:', {
        ID: id,
        错误信息: error.message,
        状态码: error.response?.status,
        响应数据: error.response?.data
      });
      throw error;
    }
  },

  // 获取群活码详细信息（包含解析后的字段）
  getGroupJoinWayDetailById: async (id) => {
    try {
      console.log('🚀 准备获取群活码详细信息，ID：', id);
      const response = await api.get(`/wework/group-join-way/${id}/detail`);
      console.log('✅ 获取群活码详细信息成功');
      return response.data;
    } catch (error) {
      console.error('❌ 获取群活码详细信息失败:', {
        ID: id,
        错误信息: error.message,
        状态码: error.response?.status,
        响应数据: error.response?.data
      });
      throw error;
    }
  },

  // 创建群活码
  createGroupJoinWay: async (data) => {
    try {
      console.log('🚀 准备创建群活码，数据：', data);
      const response = await api.post('/wework/group-join-way', data);
      console.log('✅ 创建群活码成功');
      return response.data;
    } catch (error) {
      console.error('❌ 创建群活码失败:', {
        错误信息: error.message,
        状态码: error.response?.status,
        响应数据: error.response?.data
      });
      throw error;
    }
  },

  // 更新群活码
  updateGroupJoinWay: async (id, data) => {
    try {
      console.log('🚀 准备更新群活码，ID：', id, '数据：', data);
      const response = await api.put(`/wework/group-join-way/${id}`, data);
      console.log('✅ 更新群活码成功');
      return response.data;
    } catch (error) {
      console.error('❌ 更新群活码失败:', {
        ID: id,
        错误信息: error.message,
        状态码: error.response?.status,
        响应数据: error.response?.data
      });
      throw error;
    }
  },

  // 删除群活码
  deleteGroupJoinWay: async (id) => {
    try {
      console.log('🚀 准备删除群活码，ID：', id);
      const response = await api.delete(`/wework/group-join-way/${id}`);
      console.log('✅ 删除群活码成功');
      return response.data;
    } catch (error) {
      console.error('❌ 删除群活码失败:', {
        ID: id,
        错误信息: error.message,
        状态码: error.response?.status,
        响应数据: error.response?.data
      });
      throw error;
    }
  },

  // 批量删除群活码
  batchDeleteGroupJoinWays: async (ids) => {
    try {
      console.log('🚀 准备批量删除群活码，IDs：', ids);
      const response = await api.post('/wework/group-join-way/batch-delete', { ids });
      console.log('✅ 批量删除群活码成功');
      return response.data;
    } catch (error) {
      console.error('❌ 批量删除群活码失败:', {
        IDs: ids,
        错误信息: error.message,
        状态码: error.response?.status,
        响应数据: error.response?.data
      });
      throw error;
    }
  },

  // 批量更新群活码
  batchUpdateGroupJoinWays: async (ids, updateFields) => {
    try {
      console.log('🚀 准备批量更新群活码，IDs：', ids, '更新字段：', updateFields);
      const response = await api.post('/wework/group-join-way/batch-update', { 
        ids, 
        updateFields 
      });
      console.log('✅ 批量更新群活码成功');
      return response.data;
    } catch (error) {
      console.error('❌ 批量更新群活码失败:', {
        IDs: ids,
        错误信息: error.message,
        状态码: error.response?.status,
        响应数据: error.response?.data
      });
      throw error;
    }
  },

  // 同步企微群活码列表
  syncGroupJoinWaysFromWework: async () => {
    try {
      console.log('🚀 准备同步企微群活码列表');
      const response = await api.post('/wework/group-join-way/sync');
      console.log('✅ 同步企微群活码列表成功');
      return response.data;
    } catch (error) {
      console.error('❌ 同步企微群活码列表失败:', {
        错误信息: error.message,
        状态码: error.response?.status,
        响应数据: error.response?.data
      });
      throw error;
    }
  },

  // 获取群活码统计信息
  getGroupJoinWayStatistics: async () => {
    try {
      console.log('🚀 准备获取群活码统计信息');
      const response = await api.get('/wework/group-join-way/statistics');
      console.log('✅ 获取群活码统计信息成功');
      return response.data;
    } catch (error) {
      console.error('❌ 获取群活码统计信息失败:', {
        错误信息: error.message,
        状态码: error.response?.status,
        响应数据: error.response?.data
      });
      throw error;
    }
  },

  // 根据state参数获取群活码详情
  getGroupJoinWayByState: async (state) => {
    try {
      console.log('🚀 准备根据state获取群活码详情，state：', state);
      const response = await api.get(`/wework/group-join-way/by-state/${state}`);
      console.log('✅ 根据state获取群活码详情成功');
      return response.data;
    } catch (error) {
      console.error('❌ 根据state获取群活码详情失败:', {
        state: state,
        错误信息: error.message,
        状态码: error.response?.status,
        响应数据: error.response?.data
      });
      throw error;
    }
  },

  // 复制群活码
  copyGroupJoinWay: async (id, copyRequest = {}) => {
    try {
      console.log('🚀 准备复制群活码，源ID：', id, '复制参数：', copyRequest);
      const response = await api.post(`/wework/group-join-way/${id}/copy`, copyRequest);
      console.log('✅ 复制群活码成功');
      return response.data;
    } catch (error) {
      console.error('❌ 复制群活码失败:', {
        源ID: id,
        复制参数: copyRequest,
        错误信息: error.message,
        状态码: error.response?.status,
        响应数据: error.response?.data
      });
      throw error;
    }
  }
};

export default weworkGroupJoinWayService;